import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "menu-section my-4"
};
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_4 = { class: "d-flex gap-2" };
const _hoisted_5 = {
    key: 0,
    class: "menu-grid"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "menu-media" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    key: 0,
    class: "item-type-badge"
};
const _hoisted_10 = { class: "menu-content" };
const _hoisted_11 = { class: "h6 mb-1" };
const _hoisted_12 = { class: "text-muted mb-2 item-description" };
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_14 = { class: "price" };
const _hoisted_15 = { class: "d-flex align-items-center gap-2" };
const _hoisted_16 = { class: "badge bg-light text-dark border" };
const _hoisted_17 = {
    key: 1,
    class: "text-center mt-3"
};
const _hoisted_18 = { class: "modal-header" };
const _hoisted_19 = { class: "modal-title" };
const _hoisted_20 = { class: "modal-body" };
const _hoisted_21 = {
    key: 0,
    class: "modal-image"
};
const _hoisted_22 = ["src", "alt"];
const _hoisted_23 = { class: "modal-info" };
const _hoisted_24 = { class: "modal-description" };
const _hoisted_25 = { class: "modal-details" };
const _hoisted_26 = { class: "detail-row" };
const _hoisted_27 = { class: "detail-row" };
const _hoisted_28 = { class: "modal-footer" };
import { ref, computed, getCurrentInstance } from 'vue';
// Props para recibir items dinámicos y control de paginación
export default /*@__PURE__*/ _defineComponent({
    __name: 'GastronomyMenuSection',
    props: {
        pageSize: {},
        items: {}
    },
    setup(__props) {
        const instance = getCurrentInstance();
        const $buildImg = instance?.appContext.config.globalProperties.$buildImg;
        const props = __props;
        // Items SOLO desde props (base de datos) - SIN datos estáticos
        const items = ref(props.items || []);
        const q = ref('');
        const selectedItem = ref(null);
        const filtered = computed(() => {
            const needle = q.value.trim().toLowerCase();
            if (!needle)
                return items.value;
            return items.value.filter(i => (i.name || '').toLowerCase().includes(needle) ||
                (i.description || '').toLowerCase().includes(needle) ||
                (i.category || '').toLowerCase().includes(needle));
        });
        const pageSize = computed(() => Math.max(1, props.pageSize ?? 8));
        const visibleCount = ref(pageSize.value);
        const visibleItems = computed(() => filtered.value.slice(0, visibleCount.value));
        const canShowMore = computed(() => filtered.value.length > visibleCount.value);
        const showMore = () => { visibleCount.value = Math.min(filtered.value.length, visibleCount.value + pageSize.value); };
        // const getDishImage = (item: MenuItem, itemIndex: number) => {
        //   console.log('=== getDishImage called ===')
        //   console.log('Item:', item)
        //   console.log('ItemIndex:', itemIndex)
        //   // SOLO usar image_url de la base de datos
        //   if (item.image_url) {
        //     console.log(`Using image_url from database for: ${item.name}`)
        //     return item.image_url
        //   }
        //   // Si no hay image_url, usar placeholder
        //   console.log(`No image_url found for: ${item.name}, using placeholder`)
        //   return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0xNzUgMTI1SDIyNVYxNzVIMTc1VjEyNVoiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTE4NSAxMzVIMjE1VjE2NUgxODVWMTM1WiIgZmlsbD0iI0NDQ0NDQyIvPgo8dGV4dCB4PSIyMDAiIHk9IjIwMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5OTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5TaW4gaW1hZ2VuPC90ZXh0Pgo8L3N2Zz4='
        // }
        const getDishImage = (item, itemIndex) => {
            console.log('=== getDishImage called ===');
            console.log('Item:', item);
            console.log('ItemIndex:', itemIndex);
            // SOLO usar image_url de la base de datos
            if (item.image_url) {
                console.log(`Using image_url from database for: ${item.name}`);
                // ✅ Procesar con $buildImg
                return $buildImg ? $buildImg(item.image_url) : item.image_url;
            }
            // Si no hay image_url, usar placeholder
            console.log(`No image_url found for: ${item.name}, using placeholder`);
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0xNzUgMTI1SDIyNVYxNzVIMTc1VjEyNVoiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTE4NSAxMzVIMjE1VjE2NUgxODVWMTM1WiIgZmlsbD0iI0NDQ0NDQyIvPgo8dGV4dCB4PSIyMDAiIHk9IjIwMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5OTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5TaW4gaW1hZ2VuPC90ZXh0Pgo8L3N2Zz4=';
        };
        const handleImageError = (event) => {
            console.log('=== Image Error ===');
            const target = event.target;
            console.log('Failed image URL:', target.src);
            // Fallback a una imagen placeholder si la imagen no se carga
            target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0xNzUgMTI1SDIyNVYxNzVIMTc1VjEyNVoiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTE4NSAxMzVIMjE1VjE2NUgxODVWMTM1WiIgZmlsbD0iI0NDQ0NDQyIvPgo8dGV4dCB4PSIyMDAiIHk9IjIwMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5OTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5JbWFnZW4gbm8gZGlzcG9uaWJsZTwvdGV4dD4KPC9zdmc+';
            console.log('Using fallback image');
        };
        const formatPrice = (price) => {
            const n = Math.abs(typeof price === 'string' ? parseFloat(price) : price);
            if (Number.isNaN(n))
                return 'Consultar';
            return `$${n.toFixed(0)}`;
        };
        // Convertir tipo de item a etiqueta legible
        const getItemTypeLabel = (type) => {
            const labels = {
                'room': 'Habitación',
                'service': 'Servicio',
                'offer': 'Oferta',
                'food': 'Comida',
                'drink': 'Bebida'
            };
            return labels[type] || 'Servicio';
        };
        // Función para contactar por WhatsApp
        const contactWhatsApp = (item) => {
            const message = `Hola! Me interesa ${item.name} - ${formatPrice(item.price)}. ¿Podrían darme más información?`;
            const whatsappUrl = `https://wa.me/59176765709?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, '_blank');
        };
        // Función para reservar item
        const reserveItem = (item) => {
            const message = `Hola! Quiero reservar ${item.name} - ${formatPrice(item.price)}. ¿Está disponible?`;
            const whatsappUrl = `https://wa.me/59176765709?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, '_blank');
        };
        // Funciones para el modal
        const openItemModal = (item) => {
            selectedItem.value = item;
        };
        const closeItemModal = () => {
            selectedItem.value = null;
        };
        return (_ctx, _cache) => {
            return (items.value && items.value.length > 0)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "h5 m-0" }, [
                                _createElementVNode("i", { class: "fas fa-list me-2" }),
                                _createTextVNode("Servicios ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((q).value = $event)),
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    placeholder: "Buscar servicio..."
                                }, null, 512), [
                                    [_vModelText, q.value]
                                ])
                            ])
                        ]),
                        (filtered.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                        key: item.id,
                                        class: "menu-card",
                                        onClick: ($event) => (openItemModal(item))
                                    }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("img", {
                                                src: getDishImage(item, index),
                                                alt: item.name,
                                                onError: handleImageError
                                            }, null, 40, _hoisted_8),
                                            (item.type)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(getItemTypeLabel(item.type)), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("h4", _hoisted_11, _toDisplayString(item.name), 1),
                                            _createElementVNode("p", _hoisted_12, _toDisplayString(item.description), 1),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("strong", _hoisted_14, _toDisplayString(formatPrice(item.price)), 1),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.category || getItemTypeLabel(item.type || '')), 1)
                                                ])
                                            ]),
                                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "menu-actions" }, null, -1))
                                        ])
                                    ], 8, _hoisted_6));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        (canShowMore.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("button", {
                                    class: "btn btn-outline-primary btn-sm",
                                    onClick: showMore
                                }, "Ver más")
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (selectedItem.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "modal-overlay",
                            onClick: closeItemModal
                        }, [
                            _createElementVNode("div", {
                                class: "modal-content",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"]))
                            }, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("h3", _hoisted_19, _toDisplayString(selectedItem.value.name), 1),
                                    _createElementVNode("button", {
                                        class: "modal-close",
                                        onClick: closeItemModal
                                    }, [...(_cache[6] || (_cache[6] = [
                                            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    (selectedItem.value.image_url)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("img", {
                                                src: _unref($buildImg) ? _unref($buildImg)(selectedItem.value.image_url) : selectedItem.value.image_url,
                                                alt: selectedItem.value.name
                                            }, null, 8, _hoisted_22)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("p", _hoisted_24, _toDisplayString(selectedItem.value.description), 1),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Precio:", -1)),
                                                _createTextVNode(" " + _toDisplayString(formatPrice(selectedItem.value.price)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Tipo:", -1)),
                                                _createTextVNode(" " + _toDisplayString(getItemTypeLabel(selectedItem.value.type || '')), 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("button", {
                                        class: "btn btn-whatsapp",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (contactWhatsApp(selectedItem.value)))
                                    }, [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("i", { class: "fab fa-whatsapp me-2" }, null, -1),
                                            _createTextVNode("Contactar ", -1)
                                        ]))]),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (reserveItem(selectedItem.value)))
                                    }, [...(_cache[10] || (_cache[10] = [
                                            _createElementVNode("i", { class: "fas fa-calendar me-2" }, null, -1),
                                            _createTextVNode("Reservar ", -1)
                                        ]))])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
